import { IUserLeaderboardViewModel } from 'fitbeat.models';
import { createSelector } from 'reselect';
import { IAppStore } from '../HomeWorkouts';
import { getTrackingGaugeDataFromStats } from '../utils/trackingGaugeData';

const getStatsWithGaugeData = (stats: any) => {
  if (stats) {
    const trackingGaugeData = stats
    .map((stat) => {
      if (stat.rangePercentages) {
        return {
          trackingGaugedata: getTrackingGaugeDataFromStats(
            stat.rangePercentages,
          ),
          ...stat,
        };
      }
      return stat;
    })
    .filter(Boolean);
    return trackingGaugeData;
  }
  return [];
};

const getTrackingScanStats = (state: IAppStore) => {
  return state.tracking.data.scanStats;
};

const getTrackingWorkoutStats = (state: IAppStore) => {
  return state.tracking.data.workoutStats;
};

export const trackingScanStatsSelector = createSelector(
  [getTrackingScanStats],
  (scanStats) => {
    return getStatsWithGaugeData(scanStats);
  },
);

export const trackingWorkoutStatsSelector = createSelector(
  [getTrackingWorkoutStats],
  (workoutStats) => {
    return getStatsWithGaugeData(workoutStats);
  },
);

const getLeaderboards = (state: IAppStore) => {
  return state.tracking.data.leaderboards;
};

const getInactiveLeaderboards = (state: IAppStore) => {
  return state.tracking.data.inactiveLeaderboards;
};

export const completedLeaderboardsSelector = createSelector(
  [getInactiveLeaderboards],
  (inactiveLeaderboards) => {
    return inactiveLeaderboards;
  },
);

export const activeLeaderboardsSelector = createSelector(
  [getLeaderboards],
  (leaderboards) => {
    if (leaderboards) {
      return leaderboards.filter(
        (leaderboard: IUserLeaderboardViewModel) =>
          new Date(leaderboard.endDate).getTime() > Date.now(),
      );
    }
  },
);
